import React from "react";
import { DropdownMenu, Table, Flex } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import trash from "../assets/trashIcon.png";
import edit from "../assets/edit 1.png";
import check from "../assets/check-circle (2) 1.png";

const CampaignDropDown = ({ data, approve, onDelete }) => {
  const navigate = useNavigate();
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Table.Cell style={{ cursor: "pointer" }}>...</Table.Cell>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content variant="soft" color="gray">
        <DropdownMenu.Item
          onClick={() =>
            navigate("/campaigns-form", { state: { id: data.id } })
          }
        >
          <Flex align={{ initial: "center" }} gapX={{ initial: "1" }}>
            <img
              style={{ width: "16px", height: "16px" }}
              src={edit}
              alt="edit"
            />
            <p className="font-normal text-sm text-[#121619]">Edit</p>
          </Flex>
        </DropdownMenu.Item>
        <DropdownMenu.Item onClick={() => approve(data.id)}>
          <Flex align={{ initial: "center" }} gapX={{ initial: "1" }}>
            <img
              style={{ width: "16px", height: "16px" }}
              src={check}
              alt="check"
            />
            <p className="font-normal text-sm text-[#121619]">Approve</p>
          </Flex>
        </DropdownMenu.Item>
        <DropdownMenu.Item
          // style={{ backgroundColor: "" }}
          onClick={() => onDelete(data.id)}
        >
          <Flex align={{ initial: "center" }} gapX={{ initial: "1" }}>
            <img
              style={{ width: "16px", height: "16px" }}
              src={trash}
              alt="trash"
            />

            <p className="font-normal text-sm text-[#121619]">Delete</p>
          </Flex>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default CampaignDropDown;
